// extracted by mini-css-extract-plugin
export var modal = "_ew-0";